"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/** True when viewport is at least Tailwind `md` (768px). */
export function useIsMdUp() {
  const $ = _c(2);
  const [isMdUp, setIsMdUp] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mq = window.matchMedia("(min-width: 768px)");
      const update = () => setIsMdUp(mq.matches);
      update();
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isMdUp;
}